const RequiredStar = () => {
  return <span className='text-danger fw-bold'>&nbsp;*</span>;
};

export default RequiredStar;